import { useAccessToken } from '../app/authenticate';


export default function useIsSalesforceUser() {
  const accessToken = useAccessToken();

  return accessToken?.impersonate?.entity || false;
}
